import { Box, Typography } from "@material-ui/core";
import React from "react";
import { HeadingProps } from "../../interfaces";

const ProjectPoolHeading: React.FC<HeadingProps> = ({
  title1,
  title2,
  titleRef,
}) => {
  return (
    <Box mb={2} p={0} mt={2}>
      <Typography variant="h2" color="primary" ref={titleRef}>
        {title1}{" "}
        <Typography component="span" variant="h2" color="secondary">
          {title2}
        </Typography>
      </Typography>{" "}
      {/** typegrapic box */}
    </Box>
  );
};

export default ProjectPoolHeading;
